import { linkToClassCoursesPage } from "../../links";

export function linkToRemoveClassCourseModal(
  classId?: string,
  courseId: string = ":courseId"
) {
  return `${linkToClassCoursesPage(classId)}/remove-course/${courseId}`;
}
